import { WHATSAPP_URL } from "../../config";
import { trackWhatsAppClick } from "../../analytics";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-black pb-28 pt-14 md:pb-14" data-testid="footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 sm:px-8 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="font-serif text-lg font-semibold tracking-[0.25em] text-white">
          FEDE <span className="text-gold">&</span> FITNESS ITALIA
        </p>
        <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-white/50">
          Metodo di Coaching Cristiano Tempio Vivo — Elio Briotti e Chiara Perrone. Percorsi di
          coaching online, da Malta verso tutta Italia.
        </p>
        <p className="mt-5 max-w-md text-[11px] font-light leading-relaxed text-white/35">
          Il coaching non è psicoterapia e non sostituisce professionisti sanitari, guide
          spirituali o percorsi ecclesiali. I dati condivisi in fase di prenotazione vengono
          usati solo per gestire il tuo incontro.
        </p>
      </div>
      <div className="flex flex-col gap-3 md:text-right">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("footer-whatsapp")}
          data-testid="footer-cta"
          className="text-xs font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:text-gold-bright"
        >
          Contattaci su WhatsApp
        </a>
        <p className="text-[11px] font-light text-white/35">
          © 2026 Fede & Fitness Italia · Tempio Vivo
        </p>
      </div>
    </div>
  </footer>
);
